import GetLabel from "foundation/js/getLabel"
import ProfilePicture from "../ProfilePicture/ProfilePicture";
import FormInputTextField from "../FormInputTextField/FormInputTextField";
import FormInputNameField from "../FormInputNameField/FormInputNameField";
import FormAddressField from "../FormAddressField/FormAddressField";
import FormInputEmailField from "../FormInputEmailField/FormInputEmailField";
import FormInputTextarea from "../FormInputTextarea/FormInputTextarea";
import FormCheckbox from "../FormCheckbox/FormCheckbox";
import FormInputDropdown from "../FormInputDropdown/FormInputDropdown";
import { ref, computed } from "vue";
import { useStore } from "vuex";

export default {
    name: "EditFrivilligProfile",
    components: {
        ProfilePicture,
        FormInputTextField,
        FormInputNameField,
        FormAddressField,
        FormInputEmailField,
        FormInputTextarea,
        FormInputDropdown,
        FormCheckbox
    },
    props: {
        interests: {
            type: Array,
            required: true,
        },
        userData: {
            type: Object,
            required: true,
        },
        notificationWhenCommentOnSavedPosts: {
            type: Boolean,
            required: false,
            default: false
        },
        notificationWhenDirectMessage: {
            type: Boolean,
            required: false,
            default: false
        },
        notificationWhenNewDocument: {
            type: Boolean,
            required: false,
            default: false
        },
        notificationWhenPostsOnGroups: {
            type: Boolean,
            required: false,
            default: false
        },
        addressVisible: {
            type: Boolean,
            required: false,
            default: false
        },
        phonenumberVisible: {
            type: Boolean,
            required: false,
            default: false
        },
        emailVisible: {
            type: Boolean,
            required: false,
            default: false
        },
        hasNewsletterSubscription: {
            type: Boolean,
            required: false,
            default: false
        },
        deleteProfileRedirectUrl: {
            type: String,
            required: false
        },
        hasProfileImage : {
            type: Boolean,
            required: false
        }
    },
    setup(props) {
        const store = useStore()
        const displayError = ref(false)
        const password = ref("123435678")
        const userData = ref(props.userData ?? {})
        const description = ref(props.userData.description ?? "")
        const isSubmitting = computed(()=> store.state.frivilligprofil.submitting)

        const notificationFrequency = ref(props.userData.notificationFrequency ?? "")
        const isSubscribedToNewsletter = ref(props.hasNewsletterSubscription ?? false)
        const notificationWhenCommentOnSavedPosts = ref(props.notificationWhenCommentOnSavedPosts ?? "")
        const notificationWhenPostsOnGroups = ref(props.notificationWhenPostsOnGroups ?? "")
        const notificationWhenDirectMessage = ref(props.notificationWhenDirectMessage ?? "")
        const notificationWhenNewDocument = ref(props.notificationWhenNewDocument ?? "")
        const gruppeemner = computed(() => props.interests.filter(x => x.isSelected).map(x => x.id))
        const addressVisible = ref(props.addressVisible)
        const phoneNumberVisible = ref(props.phonenumberVisible)
        const emailVisible = ref(props.emailVisible)

        const notificationfrequencyOptions = [
            { "name": "Straks", "value": "Immediately" },
            { "name": "Dagligt", "value": "Daily" },
            { "name": "Ugentligt", "value": "Weekly" },
        ]

        const url = `/${process.env.FRIVILLIGPROFIL_PICTURE_GET.replace("[id]", userData.value.id)}`
        const activeProfilePicture = ref({
            "name": "",
            "url": url, 
            "size": ""
        })

        const saveProfile = () => {
            const body = {
                profileImageSrc: activeProfilePicture.value.url,
                description: description.value,
                addressVisible: addressVisible.value,
                phonenumberVisible: phoneNumberVisible.value,
                emailVisible: emailVisible.value,
                notificationFrequency: notificationFrequency.value 
                    ? notificationFrequency.value 
                    : null,
                notificationWhenCommentOnSavedPosts: notificationWhenCommentOnSavedPosts.value,
                notificationWhenPostsOnGroups: notificationWhenPostsOnGroups.value,
                notificationWhenDirectMessage: notificationWhenDirectMessage.value,
                notificationWhenNewDocument: notificationWhenNewDocument.value,
                isSubscribedToNewsletter: isSubscribedToNewsletter.value,
                gruppeemner: gruppeemner.value
            }

            store.dispatch("frivilligprofil/editFrivilligprofil", {
                pageId: store.state.main.page_id,
                body: body,
            })
         }

        const startUserInfoOverlay = (e) => {
            store.commit('main/set_page_overlay_content_data', { userId: props.userData.id, isFrivilligContext: true })

            store.dispatch("main/openPageOverlay", {
                overlayContent: "MemberOverlayProfileCard",
                returnTarget: e.currentTarget,
            });
        }
        
        const startDeleteUserOverlay = function (e) {
            store.commit('main/set_page_overlay_content_data', { 
                userProfileId: props.userData.userProfileId,
                continueUrl: props.deleteProfileRedirectUrl
            })

            store.dispatch("main/openPageOverlay", {
                overlayContent: "FVLConfirmDeleteProfile",
                returnTarget: e.currentTarget,
            });
        };

        const setInterest = (name, value) => props.interests.find((interest) => interest.name === name).isSelected = value
        const setNotification = (name, value) => props.notificationSettings.find((setting) => setting.name === name).value = value
        const setNewsletterSubscription = (value) => isSubscribedToNewsletter.value = value

        return {
            displayError,
            description,
            addressVisible,
            phoneNumberVisible,
            emailVisible,
            activeProfilePicture,
            notificationFrequency,
            notificationWhenCommentOnSavedPosts,
            notificationWhenPostsOnGroups,
            notificationWhenDirectMessage,
            notificationWhenNewDocument,
            gruppeemner,
            isSubscribedToNewsletter,
            userData,
            password,
            notificationfrequencyOptions,
            isSubmitting,
            setInterest,
            setNotification,
            setNewsletterSubscription,
            saveProfile,
            startUserInfoOverlay,
            startDeleteUserOverlay,
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: "EditFrivilligProfile" })
        }
    }
}